// import type { ContractFunctionExecutionError } from 'viem';
import { UserRejectedRequestError } from 'viem';
import { serialize } from 'wagmi';

export const isUserRejectRequest = (err: any) => {
  if (
    err &&
    (err instanceof UserRejectedRequestError ||
      err.shortMessage === 'User rejected the request.' ||
      err.message === 'User rejected the request.')
  ) {
    return true;
  }
  return false;
};

export const isNotUserRejectRequest = (err: any) => {
  return !isUserRejectRequest(err);
};

function serializeArray(data: any[]) {
  return JSON.stringify(data, (_, value) => {
    if (typeof value === 'bigint') {
      return serialize(value);
    }
    return value;
  });
}
function serializeArgs(data: any) {
  if (Array.isArray(data)) {
    return serializeArray(data);
  }
  return String(data);
}

export const contractErrorReport = (err: any) => {
  if (isNotUserRejectRequest(err)) {
    // const contractError = err as ContractFunctionExecutionError;
    // report({
    //   address: contractError.sender || '',
    //   args: serializeArgs(contractError.args),
    //   data: `contractAddress: ${contractError.contractAddress};\n constructor: ${contractError.name};`,
    //   error: contractError.details || contractError.shortMessage,
    //   method: contractError.functionName
    // });
  }
};
